import { render, staticRenderFns } from "./TabTasks.vue?vue&type=template&id=555c200e&scoped=true"
import script from "./TabTasks.vue?vue&type=script&lang=js"
export * from "./TabTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555c200e",
  null
  
)

export default component.exports